import React from "react";
import { Navigate } from "react-router-dom";

export const config = [
    {
        path: "",
        element: React.lazy(() => import("../../Pages/Common/Homepage/index")),
    },
    {
        path: "about-us",
        element: React.lazy(() => import("../../Pages/Common/Aboutus")),
    },
    {
        path: "free-demo",
        element: React.lazy(() => import("../../Pages/Common/FreeDemo")),
    },
    {
        path: "book-demo",
        element: React.lazy(() => import("../../Pages/Common/BookDemo")),
    },
    {
        path: "reading-assessment",
        element: React.lazy(() => import("../../Pages/Common/ReadingAssessment")),
    },

    {
        path: "careers",
        element: React.lazy(() => import("../../Pages/Common/Career/career")),
    },

    {
        path: "careers/all",
        element: React.lazy(() => import("../../Pages/Common/Career/All")),
    },
    {
        path: "blogs",
        element: React.lazy(() => import("../../Pages/Common/blogs/page")),
    },
    {
        path: "blogs/:slug",
        element: React.lazy(
            () => import("../../Pages/Common/BlogDetails/details")
        ),
    },
    {
        path: "courses",
        element: React.lazy(() => import("../../Pages/Common/courses")),
    },

    {
        path: "contact",
        element: React.lazy(
            () => import("../../Pages/Common/Contactus/contactus")
        ),
    },
    {
        path: "faq",
        element: React.lazy(() => import("../../Pages/Common/FAQ/Faq")),
    },
    {
        path: "testimonials",
        element: React.lazy(
            () => import("../../Pages/Common/Testimonials/Testimonials")
        ),
    },
    {
        path: "resources",
        element: React.lazy(() => import("../../Pages/Common/ResourcesPage")),
    },
    {
        path: "resources/blog-details",
        element: React.lazy(
            () => import("../../Pages/Common/BlogDetails/details")
        ),
    },
    {
        path: "Delete",
        element: React.lazy(() => import("../../Reusable/Common/delete/image")),
    },
    {
        path: "teachers",
        element: React.lazy(() => import("../../Pages/Common/Teachers")),
    },
    {
        path: "privacy-policy",
        element: React.lazy(
            () => import("../../Pages/Common/PrivacyPolicy/policy")
        ),
    },
    {
        path: "login",
        element: React.lazy(() => import("../../Pages/Common/Login/Login")),
    },
    {
        path: "terms-and-conditions",
        element: React.lazy(
            () => import("../../Pages/Common/Terms/TermsConditions")
        ),
    },
    {
        path: "refund-policy",
        element: React.lazy(
            () => import("../../Pages/Common/RefundPolicy/RefundPolicy")
        ),
    },
    {
        path: "terms/:slug",
        element: React.lazy(
            () => import("../../Pages/Common/OfferTerms/OfferTerms")
        ),
    },
    {
        path: "guarantee",
        element: React.lazy(() => import("../../Pages/Common/Guarantee")),
    },
    {
        path: "signup/parent",
        element: React.lazy(() => import("../../Pages/Common/Login/signup")),
    },
    {
        path: "signup/tutor",
        element: React.lazy(
            () => import("../../Pages/Common/Login/signupTutor")
        ),
    },
    {
        path: "faildPartial",
        element: React.lazy(
            () => import("../../Reusable/Common/partials/failed")
        ),
    },
    {
        path: "SuccessPartial",
        element: React.lazy(
            () => import("../../Reusable/Common/partials/success")
        ),
    },
    {
        path: "student-registration-form",
        element: React.lazy(
            () => import("../../Pages/Common/StudentRegistration")
        ),
    },
    {
        path: "Student-registration/success",
        element: React.lazy(
            () => import("../../Pages/Common/StudentRegistration/signupThank")
        ),
    },
    {
        path: ":slug",
        element: React.lazy(() => import("../../Pages/Common/courses")),
    },
    {
        path: ":category/:slug",
        element: React.lazy(
            () => import("../../Pages/Common/CourseDetails/details")
        ),
    },
    {
        path: "*",
        element: React.lazy(
            () => import("../../Pages/Common/pageNotFound/pageNotFound")
        ),
    },
];
